module.exports = __webpack_public_path__ + "static/media/store-level-2.27a0de35.png";